import { render, staticRenderFns } from "./history-meal.vue?vue&type=template&id=7dd82eb5&scoped=true"
import script from "./history-meal.vue?vue&type=script&lang=ts"
export * from "./history-meal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd82eb5",
  null
  
)

export default component.exports